import React from 'react';
import { connect } from 'react-redux';
import ModalAlert from './modal-alert.component';
import { modalAlertActions } from '../../actions/modal-alert.actions';
import { switchProductType } from '../../actions/product-type.actions';

class ModalAlertContainer extends React.Component {
  render() {
      const {
          modalAlertActions,
          switchProductType,
      } = this.props;

      return (
          <ModalAlert
              alertText={this.props.text}
              btnText={this.props.btnText}
              toggleAlert={this.props.toggle}
              productType={this.props.productType}
              switchProductType={switchProductType}
              toggleAlertAction={modalAlertActions}
              secondButton={this.props.secondButton}
              showAsHtml={this.props.showAsHtml}
              addClassName={this.props.addClassName}
              overrideTextAlign={this.props.overrideTextAlign}
          />
      );
  }
}

const mapStateToProps = (state) => {
  return {
      text: state.modalAlert.text,
      toggle: state.modalAlert.toggle,
      btnText: state.modalAlert.btnText,
      productType: state.modalAlert.productType,
      secondButton: state.modalAlert.secondButton,
      showAsHtml: state.modalAlert.showAsHtml,
      addClassName: state.modalAlert.addClassName,
      overrideTextAlign: state.modalAlert.overrideTextAlign,
  }
}

const mapDispatchToProps = {
  modalAlertActions,
  switchProductType,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalAlertContainer);



// WEBPACK FOOTER //
// ./src/components/ModalAlert/modal-alert.container.js